import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  TrackingClubesDispatcher,
  trackingClubesDispatcher
} from "./TrackingClubes.dispatcher";
import {
  TrackingClubesStore,
  trackingClubesStore
} from "./TrackingClubes.store";
import TrackingClubesComponent from "../../../components/comisionesMembresiaConfiguracion/trackingClubes";

interface Props extends TrackingClubesStore, TrackingClubesDispatcher {}

@ReduxConnect(trackingClubesStore, trackingClubesDispatcher)
export default class TrackingClubesContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Tracking de Clubes" />
          <TrackingClubesComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
